<template>
  <div class="plan">
    <progressBar
      class="plan-progress"
      :arr="progressData"
      :activeIndex="progressActiveIndex"></progressBar>
    <tips class="plan-tip">
      <div class="plan-tip__line"> 1.“FBA发补货计划单”创建的同时将自动生成一 一对应的“发货计划单”;因此,如果要删除“发货计划单”必须到"销售/FBA发补货计划单"目录内先删除对应的“FBA发补货计划单”。同理,"发货单”由“发货计划单”生成，如要删除“发货单”必须先删除“FBA发补充计划单"； </div>
      <div class="plan-tip__line"> 2. 点击 "生成发货单" 后，弹窗里将显示所有 "已更新为当天物流价格" 的“发货计划单”，用户可在弹窗中选择对应的"发货计划单"进行“单独生成发货单”或“合并生成发货单”;特别提醒：没有更新为当天物流价的“发货计划单”将不能参与“生成发货单”； </div>
    </tips>
    <div class="plan-top">
      <div class="plan-top__name">跨境物流计价及发货计划</div>
      <div class="plan-top__fun">
        <div class="plan-top-item plan-top-item--date">
          <div class="plan-top-item__name">创建日期:</div>
          <el-date-picker
            size="mini"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"></el-date-picker>
        </div>
        <div class="plan-top-item plan-top-item--input">
          <el-input size="mini" placeholder="请输入发货计划单号"></el-input>
        </div>
        <div class="plan-top__btn">搜索</div>
        <div class="plan-top__btn" @click="newProductReservesBtnClick">生成发货单</div>
      </div>
    </div>
    <div class="plan-table">
      <Table height="550" width="1654" :head="planTableHead"></Table>
    </div>
  </div>
</template>

<script>
import { LogisticsNewMoodule } from './class'
import progressBar from 'components/common/progressBar';
import Table from 'components/common/Table.vue'
import tips from '../common/tips.vue';
export default {
  name: 'logisticsPricing',
  components: {
    progressBar, tips, Table
  },
  data(){
    return {
      /**进度条数据 */
      progressData: LogisticsNewMoodule.NEWPLANPROGRESSARRAY(),
      progressActiveIndex: 0,
      planTableHead: LogisticsNewMoodule.NEWPLANTABLEHEAD()
    }
  }
}
</script>

<style lang="scss" scoped>
.plan{
  width: 1800px;
  &-top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0;
    &__name{
      font-weight: bold;
      font-size: 16px;
      color: black;
    }
    &__fun{
      display: flex;
    }
    &-item{
      display: flex;
      align-items: center;
      margin-left: 10px;
      ::v-deep{
        .el-input__inner{
          width: 100px;
        }
      }
      &__name{
        font-size: 14px;
        margin-right: 5px;
      }
      &--date{
        ::v-deep{
          .el-input__inner{
            width: 180px;
          }
        }
      }
      &--input{
        ::v-deep{
          .el-input__inner{
            width: 180px;
          }
        }
      }
    }
    &__btn{
      line-height: 30px;
      padding: 0 15px;
      color: white;
      background: #00a0c7;
      margin-left: 10px;
      &:hover{
        cursor: pointer;
        opacity: .8;
      }
    }
  }
}
</style>
